import React from 'react';

export const TermsConditions = () => {
  return (
    <>
      <nav id="menu" className="navbar navbar-default navbar-fixed-top">
        <div className="container">
          <div className="navbar-header">
            <button
              type="button"
              className="navbar-toggle collapsed"
              data-toggle="collapse"
              data-target="#legal-navbar"
            >
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
            </button>
            <a className="navbar-brand" href="/">
              Blackbyrd
            </a>
          </div>
          <div className="collapse navbar-collapse" id="legal-navbar">
            <ul className="nav navbar-nav navbar-right">
              <li>
                <a href="/">Home</a>
              </li>
              <li>
                <a href="/privacy-policy">Privacy Policy</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <div className="legal-page">
        <div className="container">
          <div className="section-title">
            <h2>Terms and Conditions</h2>
            <p>Last updated March 30, 2026</p>
          </div>
          <div className="legal-card">
            <h3>Agreement to Terms</h3>
            <p>
              These Terms and Conditions ("Terms") govern your access to and use of the
              Blackbyrd AI LLC website, products, and services (collectively, the "Services").
              By accessing or using the Services, you agree to be bound by these Terms. If you
              do not agree, do not use the Services.
            </p>

            <h3>Who We Are</h3>
            <p>
              Blackbyrd AI LLC provides property management services and software tools
              designed to help property owners, managers, and sellers manage operations,
              communications, and related workflows.
            </p>

            <h3>Eligibility and Authority</h3>
            <p>
              You must be able to form a binding contract to use the Services. If you use
              the Services on behalf of a business or organization, you represent that you
              have the authority to bind that entity to these Terms.
            </p>

            <h3>Accounts, Submissions, and Accuracy</h3>
            <p>
              You agree to provide accurate, current, and complete information and to keep
              it updated. You are responsible for all activity conducted through your
              account or submissions, and for maintaining the confidentiality of any
              credentials you use to access the Services.
            </p>

            <h3>Consent to Contact</h3>
            <p>
              When you submit information through our forms, you authorize us to contact
              you at the email address you provide regarding your inquiry and our Services.
            </p>

            <h3>SMS/Text Message Consent</h3>
            <p>
              By checking the applicable SMS consent checkbox(es) on our forms, you
              expressly consent to receive text messages from Blackbyrd AI LLC at the
              phone number you provide. You understand that:
            </p>
            <p>
              • <strong>Transactional messages</strong> include account alerts, appointment
              reminders, service notifications, and other non-promotional communications
              related to your use of our Services.<br />
              • <strong>Marketing messages</strong> include promotional offers, special
              deals, and other marketing communications about our Services. Consent to
              marketing messages is optional and is not required as a condition of
              purchasing any goods or services.<br />
              • Message frequency may vary.<br />
              • Message and data rates may apply.<br />
              • You may opt out at any time by replying STOP to any message.<br />
              • For help, reply HELP or contact us at contact@blackbyrd.ai.<br />
              • Your consent to receive SMS messages is not a condition of any purchase
              or use of our Services.<br />
              • Carriers are not liable for delayed or undelivered messages.<br />
              • You must be 18 years of age or older to use this SMS service.<br />
              • We do not share your SMS consent or phone number with third parties for
              their marketing purposes. See our{' '}
              <a href="/privacy-policy">Privacy Policy</a> for more details.
            </p>

            <h3>Acceptable Use</h3>
            <p>
              You agree not to misuse the Services. Prohibited conduct includes, but is not
              limited to: attempting to gain unauthorized access, interfering with or
              disrupting the Services, introducing malware, scraping or harvesting data
              without permission, or using the Services for unlawful or fraudulent purposes.
            </p>

            <h3>Service Changes and Availability</h3>
            <p>
              We may modify, suspend, or discontinue any part of the Services at any time,
              with or without notice. We do not guarantee that the Services will be
              uninterrupted or error-free.
            </p>

            <h3>Fees and Payment (If Applicable)</h3>
            <p>
              If you purchase Services from us, you agree to pay all fees and taxes
              applicable to your purchase. Fees are non-refundable unless otherwise
              required by law or expressly stated in a separate agreement.
            </p>

            <h3>Intellectual Property</h3>
            <p>
              The Services and all related content, trademarks, logos, and software are
              owned by Blackbyrd AI LLC or its licensors and are protected by intellectual
              property laws. You are granted a limited, non-exclusive, non-transferable
              right to use the Services for your internal business or personal purposes.
            </p>

            <h3>Third-Party Services and Links</h3>
            <p>
              The Services may contain links or integrations to third-party websites or
              services. We are not responsible for their content, policies, or practices.
              Your use of third-party services is governed by their terms.
            </p>

            <h3>Confidentiality</h3>
            <p>
              If we share non-public information with you in the course of providing the
              Services, you agree to keep it confidential and to use it only for the
              intended purpose.
            </p>

            <h3>Disclaimer of Warranties</h3>
            <p>
              The Services are provided on an "as is" and "as available" basis. To the
              fullest extent permitted by law, we disclaim all warranties, express or
              implied, including warranties of merchantability, fitness for a particular
              purpose, and non-infringement.
            </p>

            <h3>Limitation of Liability</h3>
            <p>
              To the maximum extent permitted by law, Blackbyrd AI LLC will not be liable
              for any indirect, incidental, special, consequential, or punitive damages,
              or any loss of profits, revenues, data, or goodwill arising from or related
              to your use of the Services.
            </p>

            <h3>Indemnification</h3>
            <p>
              You agree to defend, indemnify, and hold harmless Blackbyrd AI LLC and its
              affiliates, officers, directors, employees, and agents from any claims,
              damages, liabilities, and expenses arising from your use of the Services or
              violation of these Terms.
            </p>

            <h3>Suspension and Termination</h3>
            <p>
              We may suspend or terminate your access to the Services at any time if we
              reasonably believe you have violated these Terms or if required to comply
              with law.
            </p>

            <h3>Governing Law and Venue</h3>
            <p>
              These Terms are governed by the laws of the state where Blackbyrd AI LLC is
              headquartered, without regard to conflict-of-law rules. Any disputes will be
              resolved exclusively in the state or federal courts located in that state,
              and you consent to their jurisdiction.
            </p>

            <h3>Changes to These Terms</h3>
            <p>
              We may update these Terms from time to time. The "Last updated" date above
              indicates when changes were made. Your continued use of the Services after
              changes become effective constitutes acceptance.
            </p>

            <h3>Contact Us</h3>
            <p>
              If you have questions about these Terms, contact us at contact@blackbyrd.ai.
            </p>
          </div>
        </div>
      </div>

      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2026 Blackbyrd AI LLC.{' '}
            <a href="/terms-and-conditions">Terms & Conditions</a> |{' '}
            <a href="/privacy-policy">Privacy Policy</a>
          </p>
        </div>
      </div>
    </>
  );
};
